import React from "react";
import { Outlet } from "react-router-dom";
const PropertySubTypeRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default PropertySubTypeRoot;
